// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Header_Logo__T_QjE"};